import { render, staticRenderFns } from "./Tabbar.vue?vue&type=template&id=05a4c083&"
import script from "./Tabbar.vue?vue&type=script&lang=js&"
export * from "./Tabbar.vue?vue&type=script&lang=js&"
import style0 from "./Tabbar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports